/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import { privacyData } from "../config/privacy-data";
import faqConfig from "../config/faq.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_FAQ_CONTENT } from "../graphql";
import { VApplication } from "../../../application";

export interface IMainSectionMethods extends IPluginMethodMap {
  getMainSectionProps(args: any): Promise<any>;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class MainSectionService implements IAgentPlugin {
  readonly methods: IMainSectionMethods;

  constructor() {
    this.methods = {
      getMainSectionProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_FAQ_CONTENT,
          variables: {
              "input": {
                "dashboard": "ADMIN"
            }
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          return {
            isEmpty:res?.data?.getFAQ?.queAns?.length === 0 ? true: false,
            data: {
              ...faqConfig,
              ...res?.data?.getFAQ,
              rows:res?.data?.getFAQ?.queAns
            },
            styles:faqConfig?.styles,
            config:faqConfig?.config
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
